import { render } from "./CertificateSkeleton.vue?vue&type=template&id=99e72636&scoped=true"
import script from "./CertificateSkeleton.vue?vue&type=script&lang=js"
export * from "./CertificateSkeleton.vue?vue&type=script&lang=js"

import "./CertificateSkeleton.vue?vue&type=style&index=0&id=99e72636&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99e72636"]])

export default __exports__